/* eslint-disable no-useless-constructor,react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './pin-search.scss';
import React, { Component } from 'react';
import BusyCounterLoadingIndicator from '../../../../sharedmodules/components/busyCounter/busy-counter-loading-indicator';
import DealerInputField from './dealer-input-fields';
import DealerMapping from './dealer-mappings';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { createUserDealerRequest } from '../../services/dealer-settings-helper';

class PinTransferSettings extends Component {

    constructor(props) {

        super(props);
        this.state = {
            isDealer: false,
        };

    }

    handleExecute = (userDetails, props) => {

        const userDealerRequest = createUserDealerRequest(userDetails);
        this.props.actions.searchPinTransferData(props.auth.getAccessToken, userDealerRequest);
        this.setState({ isDealer: true });

    };

    render() {

        const { busyCounter, userDealerMappedData } = this.props;

        return (
            <section className="dealer-settings">
                <section className="dealer-settings-panel">
                    <BusyCounterLoadingIndicator busyCounter={busyCounter} />
                    <div className="dealer-settings-header">
                        <h5>
                            <FormattedMessage id="PIN_TRANSFER_INFORMATION" />
                        </h5>
                    </div>
                    <DealerInputField
                        handleExecute={
                            (userDetails) => this.handleExecute(userDetails, this.props)}
                        handleReset={() => this.props.actions.resetUserDealerData()}
                    />
                </section>
                {this.state.isDealer && (
                    <DealerMapping
                        actions={this.props.actions}
                        auth={this.props.auth}
                        userDealerMappedData={userDealerMappedData}
                    />
                )}
            </section>
        );

    }

}

PinTransferSettings.displayName = 'PinTransferSettings';
PinTransferSettings.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object.isRequired,
    userDealerMappedData: PropTypes.object,
    getPinTransferData: PropTypes.func,
    resetUserDealerData: PropTypes.func,
    busyCounter: PropTypes.bool.isRequired,
    updateTransferComment: PropTypes.func,
};

export default PinTransferSettings;
